import { render, staticRenderFns } from "./EstrategiasPage.html?vue&type=template&id=44166bdb&external"
import script from "./EstrategiasPage.vue?vue&type=script&lang=ts"
export * from "./EstrategiasPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports